import { customFetch } from '../../../../shared/customFetch';
import { API_ROUTES } from '../../../shared/ApiRoutes';

export const getTitres = (userId: string) => {
  return customFetch.get(API_ROUTES.GESTION.GESTION_TITRE.GET_TITRE(userId));
};

export const getDetenteurs = (userId: string) => {
  return customFetch.get(API_ROUTES.DETENTEUR.GET_CLIENTS(userId));
};

export const getDetenteurTitre = () => {
  return customFetch.get(API_ROUTES.DETENTEUR.TITRE);
};

export const createDetenteur = async (det: any) => {
  let formData = new FormData();
  for (let key of Object.keys(det)) {
    formData.append(key, det[key]);
  }

  return fetch(API_ROUTES.DETENTEUR.BASE, {
    method: 'post',
    body: formData,
  })
    .then(async (res) => {
      return { statusCode: res.status, data: await res.json() };
    })
    .catch((err) => {
      return { statusCode: 500, data: err.message };
    });
};

export const updateDetenteur = async (url: string, det: any) => {
  return customFetch.patch(url, det);
};

export const emissionTitre = (data: any) => {
  return customFetch.post(API_ROUTES.GESTION.GESTION_TITRE.EMISSION, data);
};

export const operationTitre = async (data: any) => {
  let formData = new FormData();
  for (let key of Object.keys(data)) {
    formData.append(key, data[key]);
  }

  return fetch(API_ROUTES.GESTION.GESTION_TITRE.OPERATION_TITRE, {
    method: 'post',
    body: formData,
  })
    .then(async (res) => {
      return { statusCode: res.status, data: await res.json() };
    })
    .catch((err) => {
      return { statusCode: 500, data: err.message };
    });
};

export const livraisonTitre = async (data: any) => {
  let formData = new FormData();
  for (let key of Object.keys(data)) {
    formData.append(key, data[key]);
  }

  return fetch(API_ROUTES.GESTION.GESTION_TITRE.LIVRAISON, {
    method: 'post',
    body: formData,
  })
    .then(async (res) => {
      return { statusCode: res.status, data: await res.json() };
    })
    .catch((err) => {
      return { statusCode: 500, data: err.message };
    });
};

export const createFile = (data: any) => {
  return customFetch.post(API_ROUTES.GESTION.GESTION_TITRE.JUSTIFICATIF, data);
};

export const createFichier = async (det: any) => {
  let formData = new FormData();
  for (let key of Object.keys(det)) {
    formData.append(key, det[key]);
  }

  return fetch(API_ROUTES.GESTION.GESTION_TITRE.JUSTIFICATIF, {
    method: 'post',
    body: formData,
  })
    .then(async (res) => {
      return { statusCode: res.status, data: await res.json() };
    })
    .catch((err) => {
      return { statusCode: 500, data: err.message };
    });
};
